import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import { Notifier } from '@airbrake/browser'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './helpers/initFA'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/app.css'
import 'antd/dist/antd.css'

// eslint-disable-next-line no-new
new Notifier({
  projectId: 278035,
  projectKey: '11efd9f7452946e991e8a67fa6351e8f',
  environment: process.env.NODE_ENV,
})

ReactDOM.render(
  <App />,
  document.getElementById('main'),
)
